// eslint-disable-next-line
import tw from "twin.macro";
// import { Link } from "react-router-dom";
import { BiBadgeCheck } from "react-icons/bi";
import React from "react";
import { Link } from "gatsby";
import Roll from "react-reveal/Roll";

const ServiceCard = ({ title, link, list, icon }) => {
  return (
    <div tw="font-arial  py-20 px-10  bg-gradient-to-r from-gray-600  to-gray-700  text-white!  shadow-2xl h-full  rounded-tr-3xl rounded-bl-3xl  border-l-0 border-r-0 border-b-0 	border-red-600 border-solid hover:(shadow-2xl) transition-all duration-200 ease-in-out text-center hover:(transform scale-105)">
      <Roll right tw="h-full ">
        <div tw="grid gap-y-10">
          <img tw="h-20 mx-auto" src={icon} alt="" />
          <p tw="font-bold text-3xl">{title}</p>
          <div>
            {list.map((item, index) => (
              <div
                key={index}
                tw="grid grid-cols-4 items-center justify-center space-x-2 "
              >
                <BiBadgeCheck tw="text-green-600 text-2xl text-center mx-auto" />
                <p tw="col-span-3 text-left  m-0">{item}</p>
              </div>
            ))}
          </div>
          <Link
            tw="p-3  rounded-tr-3xl block rounded-bl-3xl text-white cursor-pointer bg-red-600 hover:bg-red-500 focus:outline-none border-none no-underline"
            to={link}
          >
            View details
          </Link>
        </div>
      </Roll>
    </div>
  );
};

export default ServiceCard;
